<div class="modal" *ngIf="updateStatus">
  <div class="content">
    <ng-container *ngIf="updateStatus === hcpUpdateStatus.Downloaded; else availableUpdate">
      <img src="assets/global/img/hcp-install.svg" alt="phone with arrow" />

      <h3>{{'updatedownloaded' | translate}}</h3>
      <p class="message">{{'updatedownloadedtitle' | translate}}</p>

      <div class="hint-container">
        <img src="assets/global/img/hcp-stars.svg" alt="3 stars" />
        <div class="hint-text">
          <p>{{'updatedownloadedmessage1' | translate}}</p>
          <p>{{'updatedownloadedmessage2' | translate}}</p>
        </div>
      </div>

      <div class="button-container">
        <ion-button fill="clear" (click)="updateLater()"> {{'updatealertafter' | translate}} </ion-button>
        <ion-button (click)="install()"> {{'install' | translate}} </ion-button>
      </div>
    </ng-container>
  </div>
</div>

<ng-template #availableUpdate>
  <img src="assets/global/img/hcp-network.svg" alt="phone with icon" />

  <h3>{{'updateavailable' | translate}}</h3>
  <p class="message">{{(isSpain ? 'updateavailablemessage' : 'updateavailablemessagedata') | translate}}</p>

  <div class="button-container">
    <ion-button fill="clear" (click)="updateLater()"> {{'updatealertafter' | translate}} </ion-button>
    <ion-button (click)="download()"> {{'download' | translate}} </ion-button>
  </div>
</ng-template>
